import { getLocalizedString } from "@icarius-localization/strings";

export const getCommandPaletteSteps = () => {
  const steps = [
    {
      target: '#command-palette-input',
      title: getLocalizedString("commandPaletteTourTitleSearch"),
      content: getLocalizedString("commandPaletteTourSearch"),
      disableBeacon: true,
    },
    {
      target: '#command-palette-list',
      title: getLocalizedString("commandPaletteTourTitleList"),
      content: getLocalizedString("commandPaletteTourList"),
    }
  ];

  if (typeof window !== 'undefined' && window.innerWidth >= 960) {
    steps.push({
      target: '#command-palette-footer',
      title: getLocalizedString("commandPaletteTourTitleFooter"),
      content: getLocalizedString("commandPaletteTourFooter"),
    });
  }

  return steps;
};
